const CHAT_BUTTON_SELECTOR = '#chat-button'
const FOOTER_SELECTOR = 'footer'
const FADE_DURATION_MS = 400

function initGorgiasChatFade() {
  const chatButtonEl = document.querySelector(CHAT_BUTTON_SELECTOR)
  const footerEl = document.querySelector(FOOTER_SELECTOR)

  if (!chatButtonEl || !footerEl) return false

  chatButtonEl.style.transition = `opacity ${FADE_DURATION_MS}ms ease, visibility ${FADE_DURATION_MS}ms ease`

  const observer = new IntersectionObserver(
    (entries) => {
      const [entry] = entries

      if (entry.isIntersecting) {
        chatButtonEl.style.opacity = '0'
        chatButtonEl.style.visibility = 'hidden'
      } else {
        chatButtonEl.style.opacity = '1'
        chatButtonEl.style.visibility = 'visible'
      }
    },
    { root: null, rootMargin: '0px', threshold: 0 }
  )

  observer.observe(footerEl)

  return true
}

function waitForChatButton(callback) {
  const chatButton = document.querySelector(CHAT_BUTTON_SELECTOR)

  if (chatButton) {
    callback()

    return
  }

  const mo = new MutationObserver(() => {
    if (document.querySelector(CHAT_BUTTON_SELECTOR)) {
      mo.disconnect()
      callback()
    }
  })

  mo.observe(document.body, { childList: true, subtree: true })
}

waitForChatButton(() => {
  initGorgiasChatFade()
})
